import { Inject, Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { MessageService } from '../../services/message-service/message.service';
import { KieneBackendApiService } from '../../services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { KieneSession } from '../../services/local-storage/kiene-session';
import { Ersteinrichtung } from './classes/ersteinrichtung';
import { API_BASE_URL_SERVICE } from '../../kiene-core.config';
import { VetVetRegistrationDTO } from '../../hit/hit-registrierung/classes/VetVetRegistrationDTO';

@Injectable({ providedIn: 'root' })
export class RegistrierungService {
    vetVetRegistrationsStatusErfolgreich: Subject<boolean> = new Subject();
    ersteinrichtung: Ersteinrichtung = new Ersteinrichtung(0, 0, 0);
    ersteinrichtungSubject: Subject<Ersteinrichtung> = new Subject();

    constructor(
        private readonly api: KieneBackendApiService,
        private readonly localStorageService: LocalStorageService,
        private readonly messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private readonly baseUrl: string,
    ) {}

    watchVetVetRegistrationsStatusErfolgreich() {
        return this.vetVetRegistrationsStatusErfolgreich.asObservable();
    }

    setVetVetRegistrationsStatusErfolgreich(status: boolean) {
        this.vetVetRegistrationsStatusErfolgreich.next(status);
    }

    watchErsteinrichtung() {
        return this.ersteinrichtungSubject.asObservable();
    }

    getErsteinrichtung() {
        return this.ersteinrichtung;
    }

    addVvvoErsteinrichtung(): void {
        this.ersteinrichtung.vvvo += 1;
        this.ersteinrichtungSubject.next(this.ersteinrichtung);
    }

    addHaendlerErsteinrichtung(): void {
        this.ersteinrichtung.haendler += 1;
        this.ersteinrichtungSubject.next(this.ersteinrichtung);
    }

    /**
     * registrieren eines neuen Kunden
     * der Status kann von einer beliebigen Component abgefragt werden ueber das entsprechende Subject des Services
     * <br> siehe setVetVetRegistrationsStatusErfolgreich()
     * @param vetVetRegistrationDTO
     */
    registerKunde(vetVetRegistrationDTO: VetVetRegistrationDTO): Observable<boolean> {
        const subject = new Subject<boolean>();
        vetVetRegistrationDTO.platform = 'mobil';
        this.api.post(`${this.baseUrl}kundenportal/registrieren.php`, vetVetRegistrationDTO, null).subscribe({
            next: (session: KieneSession) => {
                this.localStorageService.setCurrentUser(session);

                this.localStorageService.setCurrentMandant(session.mandanten[0]);
                this.messageService.infoMessage(`Registrierung erfolgreich.`);

                this.setVetVetRegistrationsStatusErfolgreich(true);
                this.addVvvoErsteinrichtung();
                return subject.next(true);
            },
            error: err => {
                this.setVetVetRegistrationsStatusErfolgreich(false);
                this.messageService.errorMessage('Fehler VetVet Registration! ', err);
                return subject.next(false);
            },
        });
        return subject.asObservable();
    }

    resetErsteinrichtung() {
        this.ersteinrichtung = new Ersteinrichtung(0, 0, 0);
    }
}
